import { push } from "react-router-redux";
import { stopSubmit } from "redux-form";

import api from "../services/api";
import { showError } from "./common.actions";

export const RESET_PASSWORD_FORM = "resetPassword";

export function resetPassword(newCredentials) {
  return dispatch => {
    api
      .resetPassword(newCredentials)
      .then(() => {
        dispatch(push("/log-in"));
      })
      .catch(error => {
        dispatch(stopSubmit(RESET_PASSWORD_FORM, error.response.data.errors));
        dispatch(showError(error.response.data.message));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/resetPassword.actions.js